export enum ParticipantRole {
  AGENT = 'AGENT',
  CUSTOMER = 'CUSTOMER',
  SYSTEM = 'SYSTEM'
}
